<div class="d-flex align-items-center gap-2" [ngClass]="themeClass">
    @if (shouldSpin) {
        <fdx-spinner size="sm"></fdx-spinner>
    } @else {
        @if ((iconOverride || themeType.icon) && showIcon) {
            <fa-icon [icon]="iconOverride ?? themeType.icon"></fa-icon>
        }
    }
    <div>{{titleText}}</div>
    @if (dismissible) {
        <button type="button" class="btn btn-sm btn-ghost ms-auto" (click)="close()">
            <fa-icon [icon]="closeIcon" class="no-margin"></fa-icon>
        </button>
    }
</div>
